/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react'
import './Footer.css'
import {FaFacebook} from 'react-icons/fa'
import {FiInstagram} from 'react-icons/fi'
import {IoLogoTwitter} from 'react-icons/io'

const Footer = () => {
  return (
    <footer>
       <a href="#" className="footer_logo">Portfolio</a>
       <ul className="link">
          <li><a href="#">Home</a></li>
          <li><a href="#about">About </a></li>
          <li><a href="#experience">Experience</a></li>
          <li><a href="#services">services</a></li>
          <li><a href="#portfolio">Portfolio</a></li>
          <li><a href="#testimonial">Testimonials</a></li>
          <li><a href="#contact">Contact</a></li>
       </ul>
       <div className="footer_social">
         <a href="https://facebook.com"><FaFacebook/> </a>
         <a href="https://instagram.com"><FiInstagram/></a>
         <a href="https://twitter.com"><IoLogoTwitter/> </a>
       </div>
       <div className="footer_right">
         <small>&copy; All Rights are reserved </small>
       </div>
    </footer>
  )
}

export default Footer